var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStarIcon = function SvgStarIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4128 8.1496L32.178 32.9188H7.14941L27.3149 48.2213L17.913 72.9256L40.4128 57.1045L61.3564 72.9256L53.0567 48.2213L74.0003 32.9188H48.453L40.4128 8.1496Z",
    fill: "#FFBE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2634 5L29.0286 29.7692H4L24.1655 45.0717L14.7636 69.776L37.2634 53.9549L58.207 69.776L49.9073 45.0717L70.8509 29.7692H45.3036L37.2634 5Z",
    stroke: "black",
    strokeWidth: 2.67701
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1084 68.6847L64.863 72.9252",
    stroke: "#3D7C54",
    strokeWidth: 2.67701,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8394 22.6505L28.9812 11.5424",
    stroke: "#017BFF",
    strokeWidth: 2.67701,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "star-icon.2faaa9caae155593dd15b9d82f415b8c.svg";